import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IPageVisitHistoryApiListResponse } from '@/types/pageVisitHistory';

export const pageVisitHistoryList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IPageVisitHistoryApiListResponse>> => {
    return axios.get('/api/pageVisitHistory/list', { ...config, params });
};
